import { steps } from "../constants/constants";

export const getItemsForStepsComponent = () =>
  steps.map((item) => ({
    key: item.title,
    title: item.title,
    description: item.description,
  }));
